import { Component, EventEmitter, Inject, Input, OnInit, Output, ViewChild } from '@angular/core';
import { cloneDeep } from 'lodash-es';
import { UserAccountEntity } from '@/app/platform/platform-data/models/user-account.entity';
import {
  USER_ACCOUNT_QUERIES,
  UserAccountQueries
} from '@/app/platform/platform-data/queries/types';
import { EgiAppEntity } from '@/app/platform/platform-data/models/egi-app.entity';
import {
  USER_ACCOUNT_ACTIONS,
  UserAccountActions
} from '@/app/platform/platform-data/actions/types';
import { EgiAppSelectComponent } from '@/app/platform/platform-data/components/form-controls/egi-app-select/egi-app-select.component';

export class UserGroupFilters {
  constructor(public user?: UserAccountEntity, public app?: EgiAppEntity) {}

  get isAnyActive(): boolean {
    return Object.keys(this).some(filterKey => !!this[filterKey]);
  }
}

@Component({
    selector: 'user-groups-filter',
    templateUrl: './user-groups-filter.component.html',
    styleUrls: ['./user-groups-filter.component.scss'],
    standalone: false
})
export class UserGroupsFilterComponent implements OnInit {
  @Input() set filters(v: UserGroupFilters) {
    this.filters = cloneDeep(v);
  }

  @Output() filtersChange = new EventEmitter<UserGroupFilters>();

  @ViewChild('appSelect', { static: true }) appSelectRef: EgiAppSelectComponent;

  constructor(
    @Inject(USER_ACCOUNT_ACTIONS)
    private readonly userAccountActions: UserAccountActions,
    @Inject(USER_ACCOUNT_QUERIES)
    readonly userAccountQueries: UserAccountQueries
  ) {}

  filtersClone: UserGroupFilters = new UserGroupFilters();

  ngOnInit(): void {
    this.userAccountActions.loadAll();
  }

  onUserChange(u: UserAccountEntity) {
    this.filtersClone.user = u;
    this.emitFiltersChange();
  }

  onAppChange(a: EgiAppEntity): void {
    this.filtersClone.app = a;
    this.emitFiltersChange();
  }

  clear() {
    this.filtersClone = new UserGroupFilters();
    this.appSelectRef.clear();
    this.emitFiltersChange();
  }

  private emitFiltersChange(): void {
    this.filtersChange.emit(this.filtersClone);
  }
}
